/**
 * Formats a date string into a more readable format.
 * @param dateString - The date string to format, e.g., "2023-10-01T12:00:00Z".
 * @returns 
 */
export const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-UK', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
};